import * as logger from 'logger';
import * as tenantService from 'services/tenant-service';
import * as userApi from 'api/user-api';
import * as userService from 'services/user-service';
import {
  GET_USER_PROFILE,
  GetUserProfileAction,
  LoadUserProfileAction,
  ProcessingUserAction,
  SetUserProfileAction,
  SetUserProfileErrorMessageAction,
  UPDATE_USER_PROFILE,
  UpdateUserProfileAction,
  SET_USER_PROFILE
} from './actions';
import { Middleware, MiddlewareAPI } from 'redux';
import { translations } from 'types/translations';

const UserProfileMiddleware: Middleware = store => next => async action => {

  try {
    switch (action.type) {
      case SET_USER_PROFILE:
        await setUser(store, action);
        break;

      case GET_USER_PROFILE:
        await getuserProfile(action, store);
        break;

      case UPDATE_USER_PROFILE:
        await updateUserProfile(action, store);
        break;

      default:
        break;
    }

    next(JSON.parse(JSON.stringify(action)));
  }
  catch (e) {
    const error = e as Error;
    logger.error(error, 'UserProfileMiddleware');
  }
};

async function getuserProfile(action: GetUserProfileAction, store: MiddlewareAPI) {
  store.dispatch(new LoadUserProfileAction());
  const tenantId = await tenantService.getTenantId();
  const user = await userApi.getUser(tenantId, action.userId.toString());
  store.dispatch(new SetUserProfileAction(user));
}

async function updateUserProfile(action: UpdateUserProfileAction, store: MiddlewareAPI) {
  const tenantId = await tenantService.getTenantId();
  store.dispatch(new ProcessingUserAction());
  try {
    const user = await userApi.updateUser(tenantId, action.userId.toString(), action.user);
    store.dispatch(new SetUserProfileAction(user));
  } catch (error) {
    logger.error(error, 'UserProfileMiddleware.updateUserProfile');
    store.dispatch(new SetUserProfileErrorMessageAction(translations.SaveError));
  }
}

async function setUser(store: MiddlewareAPI, action: SetUserProfileAction): Promise<void> {
  await userService.saveUser(action.user);
}

export default UserProfileMiddleware;



// WEBPACK FOOTER //
// ./src/pages/user-profile/middleware.ts